import { z } from 'zod';
import type { components } from '~~/types/Api';

export type Creative = components['schemas']['Creative'];

export const creativeSchema: z.ZodType<Creative> = z.object({
	id: z.number(),
	name: z.string(),
	type: z.string(),
	url: z.string(),
	width: z.number(),
	height: z.number(),
});
